import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Logo } from '../components/Logo';
export function LoginPage() {
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/dashboard');
  };
  return <div className="min-h-screen w-full flex flex-col md:flex-row bg-white" data-id="element-871">
      {/* Left Panel */}
      <div className="w-full md:w-1/2 p-8 md:p-12 lg:p-24 flex flex-col justify-between min-h-[50vh] md:min-h-screen" data-id="element-872">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-873">
          <Logo data-id="element-874" />
        </motion.div>

        <motion.div className="w-full max-w-sm mx-auto my-auto py-12" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-875">
          <h1 className="text-2xl text-navy-950 mb-2" data-id="element-876">Bienvenido</h1>
          <p className="text-base text-navy-600 mb-8" data-id="element-877">
            Ingrese a su cuenta para continuar
          </p>

          <form onSubmit={handleLogin} className="space-y-5" data-id="element-878">
            <div className="space-y-1.5" data-id="element-879">
              <label className="block text-sm font-medium text-navy-950" data-id="element-880">
                Email corporativo
              </label>
              <input type="email" placeholder="usuario@empresa.com" className="w-full h-10 px-3 rounded-md border border-slate-200 bg-white text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition-all" required data-id="element-881" />
            </div>

            <div className="space-y-1.5" data-id="element-882">
              <div className="flex items-center justify-between" data-id="element-883">
                <label className="block text-sm font-medium text-navy-950" data-id="element-884">
                  Contraseña
                </label>
                <a href="#" className="text-sm text-brand-500 hover:text-brand-400 transition-colors" data-id="element-885">
                  ¿Olvidó su contraseña?
                </a>
              </div>
              <input type="password" placeholder="••••••••" className="w-full h-10 px-3 rounded-md border border-slate-200 bg-white text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 transition-all" required data-id="element-886" />
            </div>

            <button type="submit" className="w-full h-10 bg-brand-500 hover:bg-brand-400 text-white text-sm font-medium rounded-md transition-colors mt-2 shadow-sm" data-id="element-887">
              Ingresar
            </button>
          </form>

          <div className="mt-6 text-center" data-id="element-888">
            <p className="text-sm text-slate-400" data-id="element-889">
              ¿No tiene cuenta?{' '}
              <button onClick={() => navigate('/onboarding')} className="text-brand-500 hover:text-brand-400 font-medium transition-colors" data-id="element-890">
                Crear cuenta
              </button>
            </p>
          </div>
        </motion.div>

        <div className="hidden md:block" data-id="element-891">
          <p className="text-xs text-slate-400" data-id="element-892">
            © 2024 WiSoft Alerts. Todos los derechos reservados.
          </p>
        </div>
      </div>

      {/* Right Panel */}
      <div className="w-full md:w-1/2 bg-navy-950 p-8 flex flex-col items-end justify-between min-h-[30vh] md:min-h-screen relative overflow-hidden" data-id="element-893">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-brand-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-894" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3 pointer-events-none" data-id="element-895" />

        <motion.div className="text-right relative z-10" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-896">
          <p className="text-xs text-slate-400 tracking-widest uppercase" data-id="element-897">
            Powered by ASAP Consulting
          </p>
        </motion.div>

        <div className="flex-1 flex items-center justify-center w-full relative z-10" data-id="element-898">
          <motion.div className="max-w-md text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} data-id="element-899">
            <h2 className="text-3xl font-light text-white mb-6 leading-tight" data-id="element-900">
              Inteligencia regulatoria <br data-id="element-901" />
              <span className="font-semibold text-brand-400" data-id="element-902">
                potenciada por IA
              </span>
            </h2>
            <p className="text-slate-400 text-base leading-relaxed" data-id="element-903">
              Monitoree disposiciones, resoluciones y alertas en tiempo real con
              búsqueda semántica avanzada.
            </p>
          </motion.div>
        </div>
      </div>
    </div>;
}